import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getMissionQnsAction = createAsyncThunk(
    'get-mission-qns',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/get-mission-link_qns?sub_cat_id=${data?.sub_cat_id}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getMissionQnsSlice = createSlice({
    name: 'get-mission-qns',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getMissionQnsAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getMissionQnsAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getMissionQnsAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getMissionQnsReducer = getMissionQnsSlice.reducer    